import { render } from "./OnboardingWeekdayRow.vue?vue&type=template&id=106fa7cf&scoped=true"
import script from "./OnboardingWeekdayRow.vue?vue&type=script&lang=js"
export * from "./OnboardingWeekdayRow.vue?vue&type=script&lang=js"

import "./OnboardingWeekdayRow.vue?vue&type=style&index=0&id=106fa7cf&scoped=true&lang=css"

import exportComponent from "/var/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-106fa7cf"]])

export default __exports__